import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'signin-callback',
  templateUrl: './signin-callback.component.html',
  styleUrls: ['./signin-callback.component.scss']
})
export class SigninCallbackComponent implements OnInit {

  constructor(private readonly router: Router, private readonly authService: AuthService) {}


  async ngOnInit() {
    await this.authService.userManager.signinCallback();
    this.router.navigate(['']);
  }

}
